var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgFoodDrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.424 8.619A3.815 3.815 0 001 12.167c0 .986.377 1.885.993 2.562L3.748 28h12.29l1.655-12.51a3.076 3.076 0 00.442-4.245c.11-.358.168-.733.168-1.112a3.814 3.814 0 00-3.275-3.771A4.056 4.056 0 0011.346 4a4.061 4.061 0 00-2.86 1.183c-.4-.14-.824-.214-1.256-.214a3.813 3.813 0 00-3.806 3.65zm12.571 3.093a1.453 1.453 0 01.84 2.336H3.708A2.178 2.178 0 015.498 10.1 2.18 2.18 0 118.99 7.493a2.422 2.422 0 014.778.558v.028a2.18 2.18 0 012.228 3.634zm-4.071 3.965l-.875 10.694H8.738l-.875-10.694h4.06zm1.634 0h2.466l-1.413 10.694h-1.927l.874-10.694zm-7.33 0l.875 10.694H5.176L3.762 15.677H6.23zm6.924-5.431a.815.815 0 101.63 0 .815.815 0 00-1.63 0zm-2.987 2.444a.815.815 0 110-1.63.815.815 0 010 1.63zm-3.53-3.53a.815.815 0 101.63 0 .815.815 0 00-1.63 0zM30.214 10.096a.8.8 0 01-.631.939l-3.283.646V13.7h3.1a2.4 2.4 0 012.4 2.4v1.518h-1.264L29.358 28.05h-7.716l-1.178-10.432H19.2V16.1a2.4 2.4 0 012.4-2.4h3.1v-3.335l4.574-.9a.8.8 0 01.94.63zm-8.14 7.522l.212 1.877h6.428l.212-1.877h-6.852zm6.46 3.477h-6.067l.212 1.878h5.642l.212-1.878zm-.394 3.478h-5.28l.212 1.877h4.856l.212-1.877zm-7.336-8.555h9.392a.8.8 0 00-.796-.718h-7.8a.8.8 0 00-.796.718z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodDrink);
export default __webpack_public_path__ + "static/media/food_drink.efdec143ba709f16bb49be10f3681907.svg";
export { ForwardRef as ReactComponent };